import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogujratcabservice() {



const cardData = {
  keyword: "Pune to Gujarat Cab Service",
  heading: "Lotus Cab: Pune to Gujarat Cab Service",

  headingDescription:
    "Lotus Cab provides reliable Pune to Gujarat Cab Service for safe and comfortable interstate travel. Whether you are traveling to Ahmedabad, Surat, Vadodara, Rajkot, or other major cities in Gujarat, we offer well-maintained AC sedans and spacious SUVs for long-distance journeys. Our experienced drivers are trained for highway and interstate driving, ensuring smooth and secure travel across state borders. Transparent per kilometer pricing with flexible one-way and round-trip options is available. We support corporate travel, family trips, and business relocations. With punctual pickup from anywhere in Pune and 24/7 booking assistance, we guarantee stress-free and dependable travel to Gujarat.",

  top: "Top Places to Visit in Gujarat with Lotus Cab",

  topPlaces: [
    {
      title: "Statue of Unity",
      description:
        "The Statue of Unity is the tallest statue in the world located near Kevadia. It is dedicated to Sardar Vallabhbhai Patel. Visitors enjoy breathtaking views and surrounding attractions. It has become a major tourist destination in Gujarat. Long-distance cab travel makes the visit comfortable. Ideal for family and group travel."
    },
    {
      title: "Somnath Temple",
      description:
        "Somnath Temple is one of the twelve Jyotirlingas of Lord Shiva. It is located on the Arabian Sea coast. Pilgrims visit throughout the year for spiritual blessings. The temple has historic and religious significance. Comfortable SUV travel is recommended for such long journeys. Reliable cab service ensures peaceful pilgrimage."
    },
    {
      title: "Dwarkadhish Temple",
      description:
        "Dwarkadhish Temple in Dwarka is dedicated to Lord Krishna. It is one of the Char Dham pilgrimage sites. Devotees visit from across India. The temple’s architecture and spiritual importance attract tourists. Long-distance taxi ensures safe travel. Ideal for religious tours."
    },
    {
      title: "Gir National Park",
      description:
        "Gir National Park is the only natural habitat of Asiatic lions. Wildlife enthusiasts visit for safari experiences. It is located in Gujarat’s Saurashtra region. SUV vehicles are ideal for such trips. Safe highway travel ensures comfortable journey. Perfect for adventure lovers."
    },
    {
      title: "Ahmedabad",
      description:
        "Ahmedabad is a major business and cultural hub in Gujarat. It is known for Sabarmati Ashram and heritage sites. Corporate and family travel is common on this route. Well-connected highways ensure smooth travel. One-way and round-trip options available. Reliable cab service ensures comfort."
    },
    {
      title: "Surat",
      description:
        "Surat is known for diamond and textile industries. Business travelers frequently visit the city. It also offers scenic riverfront attractions. Safe interstate travel is essential. Comfortable sedan and SUV options available. Ideal for corporate trips."
    },
    {
      title: "Vadodara",
      description:
        "Vadodara is famous for Laxmi Vilas Palace and cultural heritage. It is a well-developed commercial city. Family visits and business travel are common. Highway connectivity makes road travel convenient. Transparent cab pricing ensures smooth booking."
    },
    {
      title: "Rann of Kutch",
      description:
        "Rann of Kutch is known for its white desert and Rann Utsav festival. Tourists visit during winter season. It is a unique natural attraction in Gujarat. SUV travel is recommended for comfort. Long-distance cab service ensures safe journey."
    }
  ],

  services: [
    {
      name: "Pune to Ahmedabad Cab",
      description:
        "Professional cab service from Pune to Ahmedabad with safe interstate driving. AC sedans and SUVs available. Transparent per km pricing maintained. Suitable for business and family travel. Flexible one-way and round-trip options provided. Comfortable long-distance journey ensured."
    },
    {
      name: "Pune to Surat Taxi",
      description:
        "Reliable taxi service from Pune to Surat for corporate and leisure travel. Experienced highway drivers assigned. Clean and comfortable vehicles provided. Transparent fare structure followed. Affordable pricing available. Smooth interstate journey guaranteed."
    },
    {
      name: "Pune to Vadodara Cab",
      description:
        "Comfortable cab service to Vadodara with professional chauffeurs. Suitable for business and family trips. AC sedan and SUV options available. Transparent billing policy maintained. Flexible scheduling supported. Reliable long-distance travel ensured."
    },
    {
      name: "Pune to Rajkot Taxi Service",
      description:
        "Safe taxi service from Pune to Rajkot for long-distance travel. One-way and round-trip options available. Transparent per km pricing provided. Comfortable interiors maintained. Experienced drivers assigned. Stress-free travel guaranteed."
    },
    {
      name: "Affordable Pune to Gujarat Cab",
      description:
        "Budget-friendly interstate cab service. Clear fare breakdown shared before booking. No hidden charges applied. Comfortable sedan options available. Reliable and cost-effective travel solution."
    },
    {
      name: "Luxury Cab Pune to Gujarat",
      description:
        "Premium cab options available for executive and VIP travel. Plush seating enhances long journey comfort. Professional chauffeurs assigned. Well-maintained vehicles provided. Smooth and safe interstate travel ensured."
    },
    {
      name: "SUV Taxi Pune to Gujarat",
      description:
        "Spacious SUV taxis ideal for group and family travel. Extra luggage capacity available. Suitable for long-distance highway journeys. Comfortable and safe ride ensured."
    },
    {
      name: "Online Cab Booking Pune to Gujarat",
      description:
        "24/7 online booking available with instant confirmation. Transparent fare estimation displayed. Flexible departure scheduling supported. Hassle-free and secure booking experience."
    }
  ],

  tableData: [
    ["Pune to Gujarat Cab Service", "Pune to Ahmedabad Cab"],
    ["Pune to Surat Taxi", "Pune to Vadodara Cab"],
    ["Pune to Rajkot Taxi Service", "Affordable Pune to Gujarat Cab"],
    ["Luxury Cab Pune to Gujarat", "SUV Taxi Pune to Gujarat"],
    ["One Way Pune to Gujarat Cab", "Round Trip Pune to Gujarat Taxi"],
    ["Online Cab Booking Pune to Gujarat", "Corporate Taxi Pune to Gujarat"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Experienced Interstate Drivers",
      WhyChoosedescription:
        "Drivers trained for long-distance interstate travel. Safe and smooth highway driving ensured."
    },
    {
      WhyChooseheading: "Transparent Pricing",
      WhyChoosedescription:
        "Clear per kilometer fare structure maintained. No hidden charges applied."
    },
    {
      WhyChooseheading: "Flexible Travel Options",
      WhyChoosedescription:
        "One-way and round-trip bookings available. Multi-day trips supported."
    },
    {
      WhyChooseheading: "Multiple Vehicle Options",
      WhyChoosedescription:
        "Sedan and SUV categories available for comfort and group size."
    },
    {
      WhyChooseheading: "Corporate Travel Support",
      WhyChoosedescription:
        "Executive vehicles available for business travel. Monthly billing supported."
    },
    {
      WhyChooseheading: "24/7 Booking Assistance",
      WhyChoosedescription:
        "Round-the-clock support available. Immediate booking confirmation provided."
    },
    {
      WhyChooseheading: "Well-Maintained Fleet",
      WhyChoosedescription:
        "Regularly serviced vehicles provided. Comfortable interiors ensured."
    },
    {
      WhyChooseheading: "Reliable & Trusted Service",
      WhyChoosedescription:
        "On-time pickup guaranteed. Stress-free interstate travel ensured."
    }
  ]
};

const faqData = [
  { question: "How long does it take to travel from Pune to Gujarat?", answer: "Travel time depends on destination city but generally ranges between 10 to 16 hours." },
  { question: "Do you provide one-way cab to Gujarat?", answer: "Yes, one-way cab service is available with transparent single-side pricing." },
  { question: "Are SUVs recommended for long-distance travel?", answer: "Yes, SUVs are recommended for family and group travel due to comfort and luggage space." },
  { question: "Is online booking available?", answer: "Yes, online booking is available 24/7 with instant confirmation." },
  { question: "Are toll charges included?", answer: "Toll charges are shared transparently before booking confirmation." },
  { question: "Is round-trip taxi available?", answer: "Yes, round-trip taxi option is available with flexible scheduling." },
  { question: "Do you provide corporate travel service?", answer: "Yes, executive and corporate taxi services are available." },
  { question: "Is night travel safe?", answer: "Yes, experienced drivers ensure safe night highway travel." },
  { question: "Is advance booking recommended?", answer: "Advance booking is recommended for long-distance interstate trips." },
  { question: "What vehicle options are available?", answer: "Sedan and SUV categories are available depending on group size and comfort preference." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Amit Shah",
    feedback:
      "Booked Pune to Ahmedabad cab service. The journey was smooth and driver was professional. Transparent pricing and comfortable vehicle made travel easy.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Mehta",
    feedback:
      "Family trip to Surat was managed perfectly. SUV was spacious and clean. Long-distance travel felt safe and comfortable.",
    rating: 5
  },
  {
    id: 3,
    name: "Mr. Rajesh Patel",
    feedback:
      "Corporate travel from Pune to Vadodara was punctual and professional. Executive sedan provided and billing was transparent.",
    rating: 5
  }
];

























































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Gujarat Cab Service",
  "image": "https://lotuscab.com/assets/images/pune-to-gujarat-cab-service.jpg", 
  "description": "Lotus Cab provides Pune to Gujarat cab services with affordable one way and round trip options. Travel comfortably to Ahmedabad, Surat, Vadodara, Rajkot, and other Gujarat cities in sedan, SUV, and luxury cabs with professional drivers for corporate or family trips.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6300"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "10999",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-to-gujarat-cab-service"
  }
};





  return (
    <div>
      
<Helmet>
  <title>Contact: +91 8767592195 | Pune to Gujarat Cab Service | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Gujarat cab service with Lotus Cab. Affordable one way & round trip cabs to Ahmedabad, Surat, Vadodara, Rajkot & more. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune to Gujarat Cab Service, Pune to Ahmedabad Cab, Pune to Surat Taxi, Pune to Vadodara Cab, Pune to Rajkot Taxi Service, Affordable Pune to Gujarat Cab, Luxury Cab Pune to Gujarat, SUV Taxi Pune to Gujarat, One Way Pune to Gujarat Cab, Round Trip Pune to Gujarat Taxi, Online Cab Booking Pune to Gujarat, Corporate Taxi Pune to Gujarat" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/22.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetogujratcabservice;